import React from 'react';
import classes from './style.module.scss';
import Icon from "~/app/common/Icon";
import {FilePayload} from "./../index"
import { useStoreState } from '~/store';
import { getAttachmentIconSrc, isChatImageExtension, getExtensionFromName } from '~/messages/attachmentUtils';

export interface PreviewProps {
    files: FilePayload[]
    removeFile: (index: number) => void
    editFile: (index: number) => void
}

export type PreviewComponent = React.FC<PreviewProps>

const isImageFile = (file: File): boolean => {
    if (file?.type?.startsWith('image/')) {
        return true;
    }
    const fileName = typeof file === 'string' ? file : file?.name;
    return isChatImageExtension(getExtensionFromName(fileName || ''));
};

const Preview: PreviewComponent = ({files, removeFile, editFile}) => {
    const netWorkStatus = useStoreState(state => state.app.offline.status);

    return (
        <div className={classes['file-preview-container']}>
            {files.map((file, index) => {
                const isImage = isImageFile(file.file);
                const fileName = file.file?.name || 'document';

                return (
                    <div className={classes['preview']} key={index}>
                        {isImage ? (
                            <img src={file.previewUrl} alt="..." onClick={() => editFile(index)}/>
                        ) : (
                            <div className={classes['document-preview']} title={fileName}>
                                <img
                                    src={getAttachmentIconSrc(fileName)}
                                    alt=""
                                    className={classes['document-type-icon']}
                                />
                                <span className={classes['document-name']}>{fileName}</span>
                            </div>
                        )}
                        <div className={classes['actions']} >
                            {isImage && !!!netWorkStatus && (
                                <Icon name={'edit'} className={`${classes['icon']} ${classes['edit']}`} onClick={() => editFile(index)}/>
                            )}
                            <Icon name={'remove_circle'} className={`${classes['icon']} ${classes['delete']}`} onClick={() => removeFile(index)}/>
                        </div>
                    </div>
                );
            })}
        </div>
    )
}

export default Preview
